import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TextInputComponent from '../../../../commons/components/Forms/TextInputComponent';
import TextareaComponent from '../../../../commons/components/Forms/TextareaComponent';
import { STEPS, TEMPLATE_CODE } from '../../../../commons/constans/stepVideo';
import ButtonComponent from '../../../../commons/components/Forms/ButtonComponent';
import DropDownCommon from '../../../../commons/components/Dropdown';
import ModalComponent from '../../../../commons/components/Modal/ModalComponent';
import DialogComponent from '../../../../commons/components/Modal/DialogComponent';
import CheckboxComponent from '../../../../commons/components/Forms/CheckboxComponent';
import { useSelector } from 'react-redux';
import {
  converHtmlToDiv,
  converHtmlToStr,
  getDataLocalStorage,
  replaceCodeToInput,
  setLocalStorage,
  validateKeyword,
  validateKoreanOnly,
} from '../../../../utils/helpers';
import { isAndroid } from 'react-device-detect';

type Props = {
  pushDataVideoStepTwo: Function,
  steps: Object,
  goToSteps: Function,
  videoTemplate: Object,
  restrictedKeyword: Array,
};

const Step2Component = ({
  pushDataVideoStepTwo,
  steps,
  goToSteps,
  videoTemplate,
  restrictedKeyword,
}: Props) => {
  const navigate = useNavigate();
  const [focusIpt, setFocusIpt] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isUseTemplate, setIsUseTemplate] = useState(false);
  const [templateInnerHTML, setTemplateInnerHTML] = useState('');
  const [templateInnerText, setTemplateInnerText] = useState('');
  const [isCheckbox, setIsCheckbox] = useState(false);
  const [isCheckTem, setIsCheckTem] = useState(false);
  const [isShowError, setIsShowError] = useState(false);
  const [isShowValidate, setIsShowValidate] = useState({
    isShow: false,
    msg: '',
  });
  const [keywordForbidden, setKeywordForbidden] = useState([]);
  const [dataStep2, setDataStep2] = useState({
    step_2: steps.step_2,
  });
  const [errorForms, setErrorForms] = useState({
    child_name: '',
    title: '',
    content: '',
  });
  const { userInfo } = useSelector((state) => state.authReducers);

  useEffect(() => {
    scrollTo(0, 0);
    let keywordForbidden = [];
    if (restrictedKeyword && restrictedKeyword.data.length > 0) {
      restrictedKeyword.data.filter((item) => {
        keywordForbidden.push(item.content);
      });
      setKeywordForbidden(keywordForbidden);
    }
    setDataStep2({
      ...dataStep2,
      step_2: {
        ...steps.step_2,
        content_template_id: steps.step_2?.content_template_id || null,
        name_template: steps.step_2?.name_template || '',
        content: steps.step_2?.content || '',
        code: steps.step_2?.code || '',
        contentShow: steps.step_2?.contentShow || '',
      },
    });

    setTemplateInnerHTML(steps.step_2?.contentShow || '')
    setTemplateInnerText(steps.step_2?.content || '')
  }, []);

  useEffect(() => {
    if (!dataStep2?.step_2.child_name || !dataStep2?.step_2?.content_template_id || !dataStep2?.step_2?.title) {
      setFormIsValid(false);
    }else{
      setFormIsValid(true);
    }
    pushDataVideoStepTwo(dataStep2, STEPS.TWO);
  }, [dataStep2]);

  useEffect(() => {
    if (isShowModal) {
      //check localstorage
      let data = {
        name: 'useTemplate',
        userId: userInfo?.id || null,
      };
      let getData = getDataLocalStorage(data);
      if (getData) {
        setIsUseTemplate(false);
      } else {
        setIsUseTemplate(true);
      }
    }
  }, [isShowModal]);



  const handleChangeIpt = (e) => {
    let trimContent = e.target.value.trim();
    if (e.target.name == 'child_name') {
      let text = validateKoreanOnly(trimContent);
      console.log(122, text);
      setDataStep2({
        ...dataStep2,
        step_2: {
          ...dataStep2.step_2,
          [e.target.name]: text !== '' ? text.join("") : '',
        },
      });
    }else{
      setDataStep2({
        ...dataStep2,
        step_2: {
          ...dataStep2.step_2,
          [e.target.name]: trimContent != '' ? e.target.value.replace(/ +(?= )/g, '') : '',
        },
      });
    }
    setErrorForms({
      ...errorForms,
      [e.target.name]: '',
    });
  };

  const validateTemplate = (contentShow) => {
    let html = contentShow;
    //delete class errors to class
    html = html.replace(/<label class="error /g, '<label class="')
    
    let kwForbiden = false;
    let isRequired = false;

    //get all label target in HTML
    let allLabel = html.match(/<label(.+?)<\/label>/gim)

    if (allLabel?.length > 0) {
      allLabel.map((item) => {
        //get content in label
        let required = item.replace(/(<label[^>]*>)/gi, '').replace(/<\/label>/gi, '') 
        //check content
        if (required.trim() === '') {
          isRequired = true;
          //replace class to class error
          let newItem = item.replace(/<label class="/, '<label class="error ')
          html = html.replace(item, newItem)
        }else{
          //validate kw Forbidden from admim
          let invalid = validateKeyword(required, keywordForbidden);
          let lableResult;
          console.log(invalid, 'invalid');
          if (invalid.html.includes('<span>')) {
            kwForbiden = true;
            //replace content label span to html
            // lableResult = item.replace(required, invalid.html)
            // html = html.replace(item, lableResult);
          }
          lableResult = item.replace(required, invalid.html)
          if (kwForbiden) {
            html = html.replace(item, lableResult);
          }
        }
      })
    }
    if (!kwForbiden) {
      html = html.replace(/(<span>|<\/span>)/gim, ' ');
    }
    return { kwForbiden, isRequired, html}
  }

  const handleChangeSelect = (e) => {
    let name_template = '';
    let content_template = '';
    let content_show = '';
    let code = '';
    setErrorForms({
      ...errorForms,
      content: '',
    });

    videoTemplate.data.map((item, idx) => {
      if (item.id == +e.id) {
        name_template = item.title;
        // content_template = item.content.replace(/{name}/g, dataStep2?.step_2?.child_name ?? '{name}');
        content_show = converHtmlToStr(TEMPLATE_CODE, item.code, steps.step_1?.character_pose_name);
        content_show = content_show.replace(/{name}/g, `<em class="name">이름</em>`);
        console.log(content_show, 'content_show');
        content_template = item.content
        code = item.code
      }
    });
    // content_show = content_show ? converHtmlToDiv(replaceCodeToInput(content_show, code)) : dataStep2.step_2.contentShow
    setDataStep2({
      ...dataStep2,
      step_2: {
        ...dataStep2.step_2,
        ['content_template_id']: e.id,
        name_template: name_template,
        content: content_template ? content_template : dataStep2.step_2.content,
        code: code,
        contentShow: content_show,
      },
    });

    setTemplateInnerHTML(content_show)
    setTemplateInnerText(content_template ? content_template : dataStep2.step_2.content)
    //validate template
    // let invalid = validateTemplate(content_show)
    // if (invalid.kwForbiden || invalid.isRequired) {
    //   setIsCheckTem(true);
    //   document.getElementById('text-template').innerHTML = invalid.html
    //   document.getElementById('text-template-selected').innerHTML = invalid.html
    // }
  };

  const onInputTemplate = (e) => {
    setTemplateInnerText(document.getElementById('text-template').innerText);
    setTemplateInnerHTML(document.getElementById('text-template').innerHTML);
  };

  const onFocusPopupTemplate = () => {
    setIsShowValidate({
      isShow: false,
      msg: '',
    });
  }

  const onKeyDown = (e) => {
    if (e.which === 13 || e.keyCode == 13) {
      e.preventDefault();
      return;
    }
  }

  const handleSubmitTemplate = () => {
    setIsShowError(false);
    let invalid = validateTemplate(document.getElementById('text-template').innerHTML)
    document.getElementById('text-template').innerHTML = invalid.html
    document.getElementById('text-template-selected').innerHTML = invalid.html
    setTemplateInnerHTML(invalid.html);
    setDataStep2({
      ...dataStep2,
      step_2: {
        ...dataStep2.step_2,
        content: templateInnerText,
        contentShow: invalid.html,
      },
    });
    console.log(invalid, 'invalidinvalidinvalid');
    if (invalid.kwForbiden || invalid.isRequired) {
      setIsCheckTem(true);
      setIsShowValidate({
        isShow: true,
        msg: '입력 금지 키워드 입니다.',
      });
      return;
    } else {
      setIsCheckTem(false);
      setIsShowValidate({
        isShow: false,
        msg: '',
      });
    }
    
    setIsShowModal(false);
  };

  const handleCloseValidate = () => {
    setIsShowValidate({
      isShow: false,
      msg: '',
    });
  }

  const handleClose = () => {
    setIsShowError(false);
    handleFocusTemplate();
  }

  const handleCloseTemplate = () => {
    setTemplateInnerText(dataStep2.step_2.content)
    setTemplateInnerHTML(dataStep2.step_2.contentShow)
    document.getElementById('text-template').innerHTML = dataStep2.step_2.contentShow
    // document.getElementById('text-template-selected').innerHTML = converHtmlToDiv(dataStep2.step_2.content);
    setIsShowModal(false);
    setIsShowValidate({
      isShow: false,
      msg: '',
    });
  };

  const handleFocusTemplate = () => {
    return;
    if (dataStep2.step_2.content_template_id) {
      // console.log(dataStep2.step_2.contentShow, 'dataStep2.step_2.contentShow');
      document.getElementById('text-template').innerHTML = dataStep2.step_2.contentShow
      setIsShowModal(true);
    }
  };

  const handleCloseUseTemplate = () => {
    setIsUseTemplate(false);
    //set item in localstorage
    let dataLocalStorage = {
      userId: userInfo.id,
      name: 'useTemplate',
    };
    if (isCheckbox) {
      setLocalStorage(dataLocalStorage);
    }
  };

  const handleChangeNoSee = (e) => {
    setIsCheckbox(e.target.checked);
  };

  const validateKeywordFobiden = (name, kw) => {
    console.log(kw, 'kw');
    let invalidArr = kw.filter(item => name.includes(item))
    if (invalidArr.length > 0) {
      setIsCheckTem(true);
      setIsShowValidate({
        isShow: true,
        msg: `("${invalidArr}")는 금지어 입니다. <br /> 변경 후 다시 시도해주세요.`,
      });
      return false;
    } else {
      setIsCheckTem(false);
      setIsShowValidate({
        isShow: false,
        msg: '',
      });
      return true;
    }
  }

  const applyChildnameToTemplate = () => {
    console.log(dataStep2.step_2.content, 'dataStep2.step_2.content');
    // setDataStep2({
    //   ...dataStep2,
    //   step_2: {
    //     ...dataStep2.step_2,
    //     content: dataStep2.step_2.content.replace(/{name}/g, dataStep2.step_2.child_name),
    //   },
    // })

    pushDataVideoStepTwo({
      ...dataStep2,
      step_2: {
        ...dataStep2.step_2,
        content: dataStep2.step_2.content.replace(/{name}/g, dataStep2.step_2.child_name),
      },
    }, STEPS.TWO);
  }

  const goToStep = (step) => {
    if (step === STEPS.THREE) {
      let newErrorsState = { ...errorForms };
      let formIsValid = true;
      if (!dataStep2?.step_2?.child_name) {
        formIsValid = false;
        newErrorsState = {
          ...newErrorsState,
          child_name: '아이의 이름을 입력해주세요.',
        };
      }

      if (!dataStep2?.step_2?.title) {
        formIsValid = false;
        newErrorsState = {
          ...newErrorsState,
          title: '영상편지 제목을 입력해주세요.',
        };
      }

      if (!dataStep2?.step_2?.content_template_id) {
        formIsValid = false;
        newErrorsState = {
          ...newErrorsState,
          content: '편지 내용을 입력해주세요.',
        };
      }
      
      if (!formIsValid) {
        setFormIsValid(formIsValid);
        setErrorForms(newErrorsState);
      } else {
        let invaKw = validateKeywordFobiden(dataStep2.step_2?.child_name + dataStep2.step_2?.title, keywordForbidden);
        if (invaKw) {
          applyChildnameToTemplate();
          goToSteps(step);
        }
      }
    } else {
      let invaKw = validateKeywordFobiden(dataStep2.step_2?.child_name + dataStep2.step_2?.title, keywordForbidden);
      if (invaKw) {
        applyChildnameToTemplate();
        goToSteps(step);
      }
    }
  };

  const sublabel = <div>성을 제외한 이름으로 입력하면<br />더 자연스러운 편지를 완성할 수 있어요.</div>

  return (
    <>
      <h3>
        영상제작을 위한 <span>정보를 선택</span>해주세요!
      </h3>
      <div className={`step-form ${focusIpt ? 'show-key-board' : ''}`}>
        <div className="form-group">
          <TextInputComponent
            label={'자녀 이름'}
            sublabel={sublabel}
            isRequired={true}
            errorMsg={!formIsValid ? errorForms.child_name : ''}
            placeHolder={'이름을 한글로 입력하세요'}
            id={'js-child-name'}
            name={'child_name'}
            value={dataStep2.step_2.child_name}
            handleChange={handleChangeIpt}
            disabled={false}
            readonly={false}
            maxLength={5}
            showCountLength={true}
            autoComplete={false}
          />
        </div>
        <div className="form-group">
          <TextInputComponent
            label={'영상편지 제목'}
            isRequired={true}
            errorMsg={
              !formIsValid && errorForms.title != '' ? errorForms.title : ''
            }
            placeHolder={'영상편지의 제목을 입력하세요'}
            id={'js-title'}
            name={'title'}
            value={dataStep2.step_2.title}
            handleChange={handleChangeIpt}
            disabled={false}
            readonly={false}
            maxLength={20}
            autoComplete={false}
            showCountLength={true}
          />
        </div>
        <div className="form-group none-border">
          <label className="title-content">영상편지의 내용</label>
          <label className="notice-content">
            편지 내용으로 사용할 템플릿을 선택해 주세요.
          </label>
          <DropDownCommon
            customClass={'mb-1'}
            dataList={[
              ...videoTemplate.data,
            ]}
            nameDisplay={dataStep2.step_2?.name_template || '선택해주세요.'}
            handleClick={handleChangeSelect}
            idActive={dataStep2.step_2.content_template_id || ''}
            keyName={'title'}
            errorMes={errorForms.content}
          />
            <div className="textarea-group" onClick={() => handleFocusTemplate()}>
              <div
                id="text-template-selected"
                className="content-template-selected"
                dangerouslySetInnerHTML={{
                  __html: dataStep2.step_2.content_template_id ? dataStep2.step_2.contentShow : '',
                }}
                readonly
                data-placeholder="내용을 입력해주세요."
              >

              </div>
            </div>
            {!formIsValid && errorForms.content != ''
              ? <span className="input-error show">
                {errorForms.content}
              </span>
              : ''}
        </div>
        <div className="button">
          <ButtonComponent
            label={`이전 단계`}
            customClass="btn btn-default"
            handleClick={() => goToStep(STEPS.ONE)}
            type={`button`}
            cssClass={`prev`}
          />
          <ButtonComponent
            label={`다음 단계`}
            customClass="btn btn-default"
            handleClick={() => goToStep(STEPS.THREE)}
            type={`button`}
            disabled={!formIsValid}
          />
        </div>

        <DialogComponent
          id={`js-use-template-step2`}
          children={``}
          show={isUseTemplate}
          displayClose={false}
          title={`주의사항`}
          closeBtn={`확인`}
          handleClose={handleCloseUseTemplate}
          className={`popup-use-template-step2`}
          classOverlay={`overlay-popup-use-template-step2`}
        >
          <div className="content-template">
            <div className="text">
              <div className="text-top">
                <span className="text-danger">* </span>
                <span>숫자 사용 시 발음에 유의하여 작성해주세요.</span>
                <br />
                <span>ex) 3학년 > 삼학년(o)</span>
                <br />
                <span>양치 3번 > 양치 삼번(x)</span>
                <br />
                <span>양치 세번으로 작성해야합니다.</span>
              </div>
              <div className="text-bottom">
                <span className="text-danger">* </span>
                <span>문장간 띄어 읽기를 원하시면 마침표(.)를 </span>
                <br />
                <span>뒤에 붙여주세요.</span>
              </div>
            </div>
            <div className="no-see-today">
              <CheckboxComponent
                value={isCheckbox}
                handleChange={handleChangeNoSee}
              />
              <span className="text-no-see">오늘 하루 보지 않기</span>
            </div>
          </div>
        </DialogComponent>

        <DialogComponent
          id={`js-template-step2`}
          children={``}
          show={isShowModal}
          displayClose={true}
          title={`편지 내용`}
          closeBtn={`취소`}
          customBtn={`완료`}
          handleCustom={handleSubmitTemplate}
          handleClose={handleCloseTemplate}
          className={`popup-template-step2`} // ${isShowValidate.isShow ? 'disabled-popup' : ''}
          // disabledCustom={isShowValidate?.isShow || false}
        >
          <div className="content-template">
            <div className="content-dialog">
              <div
                contenteditable={'false'}
                onInput={onInputTemplate}
                id="text-template"
                className="content-template-popup"
                dangerouslySetInnerHTML={{
                  __html: dataStep2.step_2.contentShow || '',
                }}
                onFocus={onFocusPopupTemplate}
                onKeyDown={onKeyDown}
              >

              </div>
            </div>
          </div>
          <div className="img-position">
            <img src="/images/template.png" alt="" />
          </div>
        </DialogComponent>

        <DialogComponent 
          id={`js-validate-keyword`} 
          children={``} 
          show={isShowValidate?.isShow || false} 
          title={`알림`} 
          closeBtn={`확인`}
          handleClose={handleCloseValidate}
          className={`popup-validate-keyword`}
          classOverlay="overlay-popup-validate-keyword"
        >
          <div className="content-validate-keyword">
            <div  className='text' 
                  dangerouslySetInnerHTML={{
                  __html: isShowValidate?.msg || '',
                  }
            }>
            </div>
          </div>
        </DialogComponent>

        <DialogComponent 
          id={`js-validate-keyword`} 
          children={``} 
          show={isShowError} 
          title={`알림`} 
          closeBtn={`확인`}
          handleClose={handleClose}
          className={`popup-validate-keyword`}
          classOverlay="overlay-popup-validate-keyword"
        >
          <div className="content-validate-keyword">
            <div className='text'>
              금지어가 입력되었거나 미입력된 곳이 존재합니다.<br />
              편지 내용을 확인해주세요.
            </div>
          </div>
        </DialogComponent>
      </div>
    </>
  );
};

export default Step2Component;
